<template>
  <div class="c-dev">
    <div class="c-dev__columns-container l-columns-container">
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
      <div class="c-dev__column l-column--1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dev'
}
</script>

<style lang="scss" scoped>
@import "../vars";

.c-dev {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 111111111;
  display: none;
  // display: flex;
  justify-content: center;
  pointer-events: none;

  &__column {
    outline: 1px solid blue;
  }

  &__columns-container {
    justify-content: space-between;
    padding-right: $pageGutter;
    padding-left: $pageGutter;
    outline: 1px solid red;
  }
}

.xdebug-var-dump {
  position: relative;
  z-index: 1;
  background-color: white;
  border: 1px solid red;
}
</style>
